<template>
  <form class="feedbackForm">
    <label class="formLabel">Title *</label>
    <input
      v-model="reportTitle"
      class="reportInput"
      :class="{ invalidInput: titleFaulty }"
      maxlength="256"
      placeholder="Title of the feedback"
      required
      @input="resetTitleBorder()"
    />
    <label class="formLabel">URL of Patient or 3D model</label>
    <input
      v-model="assetUrl"
      class="reportInput"
      :class="{ invalidInput: urlFaulty }"
      maxlength="1024"
      placeholder="URL of Patient or 3D model"
      required
      @input="resetUrlBorder()"
    />
    <label class="formLabel">Description *</label>
    <textarea
      v-model="reportDescription"
      class="reportInput"
      :class="{ invalidInput: descriptionFaulty }"
      maxlength="1024"
      placeholder="Description"
      required
      rows="4"
      @input="resetDescriptionBorder()"
    >
    </textarea>
    <div class="requiredFieldHint">* Fields are required</div>
    <div>&nbsp;</div>
    <div class="radioContainer">
      <label class="formLabel"
        >Do you want to stay informed about the progress?</label
      >
      <md-radio
        v-model="userUpdateRequestedString"
        class="md-primary"
        value="Yes"
        >Yes</md-radio
      >
      <md-radio
        v-model="userUpdateRequestedString"
        class="md-primary"
        value="No"
        >No</md-radio
      >
    </div>
  </form>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import detectOsAndBrowser from "./osandbrowserdetectutil.js";
import appSettings from "./appSettings";

export default {
  name: "AppFeedbackPage",
  data: () => ({
    titleFaulty: false,
    urlFaulty: false,
    descriptionFaulty: false,
    reportTitle: null,
    assetUrl: null,
    reportDescription: null,
    userUpdateRequestedString: "No",
    userUpdateRequested: false,
  }),
  watch: {
    userUpdateRequestedString(newValue) {
      this.userUpdateRequested = newValue == "Yes" ? true : false;
    },
  },
  created() {
    this.resetData();
    this.fillUrl();
  },
  methods: {
    ...mapState(["selectedGroup"]),
    ...mapGetters(["lastBreadcrumb", "isHome"]),
    ...mapActions(["postAzure"]),
    async submitUserFeedback() {
      if (
        !this.validateForm(
          this.reportTitle,
          this.assetUrl,
          this.reportDescription
        )
      )
        return;

      var osAndBrowserInfo = await detectOsAndBrowser();

      const userFeedback = {
        title: this.reportTitle,
        description: this.reportDescription,
        contextUrl: this.assetUrl,
        osAndVersion: osAndBrowserInfo.os,
        browserAndVersion: osAndBrowserInfo.browser,
        userUpdateRequested: this.userUpdateRequested,
      };
      await this.postAzure({
        url: `${appSettings.remoteurl}/api/userfeedback`,
        metadata: userFeedback,
      });
    },
    validateForm(title, url, desc) {
      let isValid = true;
      if (!title || !desc) {
        if (!title) this.titleFaulty = true;
        if (!desc) this.descriptionFaulty = true;
        isValid = false;
      }
      if (url) {
        try {
          new URL(url);
        } catch {
          this.urlFaulty = true;
          isValid = false;
        }
      }
      if (
        (title && title.length > 256) ||
        (url && url.length > 1024) ||
        (desc && desc.length > 1024)
      ) {
        alert("Too many characters in the field !");
        isValid = false;
      }

      return isValid;
    },
    resetTitleBorder() {
      this.titleFaulty = false;
    },
    resetUrlBorder() {
      this.urlFaulty = false;
    },
    resetDescriptionBorder() {
      this.descriptionFaulty = false;
    },
    fillUrl() {
      if (this.isHome) return;

      this.assetUrl = `https://${appSettings.host}/${this.selectedGroup.id}/${this.lastBreadcrumb.asset.id}`;
    },
    resetData() {
      this.reportTitle = null;
      this.assetUrl = null;
      this.reportDescription = null;
      this.userUpdateRequestedString = "No";
      this.userUpdateRequested = false;
      this.titleFaulty = false;
      this.urlFaulty = false;
      this.descriptionFaulty = false;
    },
  },
};
</script>
<style scoped>
.reportInput {
  background-color: #2d6b7d;
  border-radius: 12px;
  border: 0;
  color: white;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  resize: none;
}
.reportInput:focus {
  outline: none;
}
::placeholder {
  color: #d0d0d0;
}
form {
  margin-left: 20px;
  margin-right: 20px;
}
form .reportInput {
  margin-top: 6px;
  margin-bottom: 12px;
}
form .unusableCheck {
  float: left;
  width: 60px;
  transform: scale(1.25);
}
.formLabel {
  display: flex;
}
.inputLabel {
  float: left;
  font-size: 16px;
}
.bugIcon {
  left: 50%;
  top: 12px;
}
.feedbackDialog {
  align-items: center;
  justify-content: center;
}
.descriptionText {
  width: 70%;
  height: 100px;
}

.requiredFieldHint {
  display: flex;
}

.radioContainer {
  display: flex;
}

.radioContainer .md-radio {
  --md-theme-default-primary: white;
  margin: 0 12px 0 24px;
}
.invalidInput {
  border: 2px solid red;
}
#menuLogo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 12px;
}
#menuLogo img {
  width: 50px;
}

.md-dialog-title {
  text-align: center;
}
.md-dialog-container {
  max-height: 90%;
}
.feedbackForm {
  display: flex;
  flex-direction: column;
}
</style>
